<ng-container [formGroup]="formGroup">

  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Trustees</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="add()">
        Add a Trustee
      </lds-button>
    </div>
  </div>

  <div formArrayName="trustees">
    <ng-container *ngIf="form.controls.length > 0; else tplNoTrustees">
      <app-inline-item
        *ngFor="let trusteeForm of form.controls; let i = index"
        [form]="trusteeForm"
        [isExpandable]="true"
        [initiallyExpanded]="expandedIndex === i"
        (delete)="remove(i)">
        <inline-summary>
          <div class="row">
            <div class="col-9">
              {{ trusteeForm.controls.trustee.value?.name ?? '-' }}
            </div>
          </div>
        </inline-summary>
        <inline-content>
          <div class="row" [formGroupName]="i">
            <div class="col-9">
              <app-contact-search formControlName="trustee" label="Trustee">
              </app-contact-search>
            </div>
          </div>
        </inline-content>
      </app-inline-item>
    </ng-container>
    <ng-template #tplNoTrustees>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      minlength: 'At least one trustee is required',
      required: 'At least one trustee is required'
    }">
  </lds-form-feedback>
</ng-container>
